// src/js/widgets/manager-requests/types.ts

export type RequestStatus =
  | 'Новая'
  | 'В работе'
  | 'Требуется информация'
  | 'Отклонена'
  | 'Исполнена';

export type ApiStatus = 'new' | 'in-progress' | 'request-information' | 'completed' | 'rejected';

export const statusToApi: Record<RequestStatus, ApiStatus> = {
  Новая: 'new',
  'В работе': 'in-progress',
  'Требуется информация': 'request-information',
  Исполнена: 'completed',
  Отклонена: 'rejected',
};

export const apiToStatus: Record<ApiStatus, RequestStatus> = {
  new: 'Новая',
  'in-progress': 'В работе',
  'request-information': 'Требуется информация',
  completed: 'Исполнена',
  rejected: 'Отклонена',
};

export function normalizeStatus(apiStatus: string): RequestStatus {
  return apiToStatus[apiStatus as ApiStatus] || 'Новая';
}

export interface Reply {
  id: number;
  message: string;
}

export interface StatusHistoryEntry {
  date: string;
  status: RequestStatus;
}

export interface Request {
  id: number;
  createdAt: string;
  email?: string;
  companyName?: string;
  status: RequestStatus;
  text?: string;
  history?: StatusHistoryEntry[];
  replies?: Reply[];
  files?: Array<{
    name: string;
    size: string;
    type: string;
    url: string;
  }>;
  fields?: FormField[];
}

export interface UpdateStatusPayload {
  status: RequestStatus;
  files?: File[];
}

export interface SendReplyPayload {
  message: string;
}

export interface ApiResponse<T = unknown> {
  success: boolean;
  msg: string;
  data?: T;
}

export type ManagerRole = 'managerr' | 'managera' | 'managerp';
export type ApiRequestType = 'resident' | 'auditory' | 'permission';

export const roleToType: Record<ManagerRole, ApiRequestType> = {
  managerr: 'resident',
  managera: 'auditory',
  managerp: 'permission',
};

export interface FormField {
  fieldName: string;
  fieldValue: string;
}
